import script from "./PortalFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortalFooter.vue?vue&type=script&setup=true&lang=ts"

import "./PortalFooter.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__